// extracted by mini-css-extract-plugin
export default {"wrapper":"User_wrapper__8KmkD"};